import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ContentBlock } from '../../models';

@Component({
  selector: 'app-content-block-container',
  templateUrl: './content-block-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockContainerComponent implements OnInit {
  @Input() blocks: ContentBlock[] = [];

  defaultBlockIndexClasses: ContentBlock[] = [];

  test = { hoi: '' };

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.defaultBlockIndexClasses = this.blocks.filter(a => a.blockType === 'default');
  }

  trackByFn(index: number, block: ContentBlock) {
    return block.id;
  }

  getCountClass(block: ContentBlock) {
    const indexOf = this.defaultBlockIndexClasses.indexOf(block);
    return indexOf === -1 ? '' : `is--${(indexOf % 3) + 1}`;
  }
}
